import axios from 'axios';
import { tApi } from 'tplus-api';

export default class QueryApi {

  static async webapiProxyReq(...args) {
    const resp = await tApi(...args);
    // let json = resp.data;
    // if(typeof(json) == 'string'){
    //   json = JSON.parse(resp.data.Value);
    // }
    return resp;
  }

  // 获取查询项
  static async getPlanItems(menuCode) {
    const method = 'chanjet.EAP.QueryExt.MBSearchPlanInfo.GetMBVouSearchPlanByMenuCode';
    const resp = await this.webapiProxyReq({ menuCode }, method, false);
    return resp.data;
  }

   // 获取查询项
   static async getSystemItems(menuCode) {
    const method = 'chanjet.EAP.QueryExt.MBSearchPlanInfo.GetVouSearchPlanByMenuCode';
    const resp = await this.webapiProxyReq({ menuCode }, method, false);
    return resp.data;
  }

    // 获取查询项
    static async getPlanItemsByMenuCodeAndName(menuCode,name) {
      const method = 'chanjet.EAP.QueryExt.MBSearchPlanInfo.GetMBVouSearchPlanByMenuCodeAndName';
      const resp = await this.webapiProxyReq({ menuCode,name }, method, false);
      return resp.data;
    }

  // 获取上次查询数据
  static async getPlanData(planId) {
    const method = 'chanjet.EAP.QueryExt.MBSearchPlanInfo.GetMBVouSearchPlanData';
    const resp = await this.webapiProxyReq({ planId }, method, false);
    return resp.data;
  }

  //保存
  static async savePlanData(planId, data) {
    const method = 'chanjet.EAP.QueryExt.MBSearchPlanInfo.SaveMBVouSearchPlanData';
    const resp = await this.webapiProxyReq({ planId, data }, method, false);
    return resp.data;
  }

  //保存系统
  static async saveSysPlanData(planId, data) {
    const method = 'chanjet.EAP.QueryExt.MBSearchPlanInfo.SaveVouSearchPlanData';
    const resp = await this.webapiProxyReq({ planId, data }, method, false);
    return resp.data;
  }

  // 如果是系统方案，就生成用户方案 保存
  static async copyPlanData(planId, data) {
    const method = 'chanjet.EAP.QueryExt.MBSearchPlanInfo.CopyMBVouSearchPlan';
    const resp = await this.webapiProxyReq({ planId, data }, method, false);
    return resp.data;
  }
  
  // 如果是系统方案，就生成用户方案 保存
  static async updateMBVouSearchItems(planId, data) {
    const method = 'chanjet.EAP.QueryExt.MBSearchPlanInfo.UpdateMBVouSearchItems';
    const resp = await this.webapiProxyReq({ planId, data }, method, false);
    return resp;
  }

  // // 获取查询项
  // static async getPlanItems(planId){
  //   const method = 'chanjet.EAP.QueryExt.MBSearchPlanInfo.GetMBPlanItems';
  //   const resp = await this.webapiProxyReq({planId},method,false);
  //   return resp.data;
  // }

  // // 获取上次查询数据
  // static async getPlanData(planId){
  //   const method = 'chanjet.EAP.QueryExt.MBSearchPlanInfo.GetMBPlanData';
  //   const resp = await this.webapiProxyReq({planId},method,false);
  //   return resp.data;
  // }

  // 获取参照基本信息
  static async getRefBase(key) {
    const method = 'chanjet.EAP.ReferInfos.OpenApi.RefInfoOpenApi.GetRefBaseInfo';
    const resp = await this.webapiProxyReq({ key }, method, false);
    return resp;
  }

  // 获取参照列信息
  static async getRefColumnSets(refDataSourceKey, refObject) {
    const method = 'chanjet.EAP.ReferInfos.OpenApi.RefInfoOpenApi.GetColumnCaption';

    const resp = await this.webapiProxyReq({ refDataSourceKey, refObject }, method, false);
    return resp.Data;
  }

  // 获取参照数据信息
  static async getRefData(type, args) {
    const method = type === 'DropDownList' ?
      'chanjet.EAP.ReferInfos.OpenApi.RefInfoOpenApi.GetItemList' :
      'chanjet.EAP.ReferInfos.OpenApi.RefInfoOpenApi.GetDropDownData';
    const resp = await this.webapiProxyReq({ para: args }, method, false);
    return resp.Data;
  }

  //获取枚举信息
  static async getEnumItems(args) {
    if(args.where){
      args.where = args.where.replace('from','4921b24ee30f86fd')
    }
    const method = 'chanjet.EAP.ReferInfos.OpenApi.RefInfoOpenApi.GetEnumItems';
    const resp = await this.webapiProxyReq({ para: args }, method, false);
    return resp;
  }

  // //保存
  // static async savePlanData(planId,data){
  //   const method = 'chanjet.EAP.QueryExt.MBSearchPlanInfo.SaveMBPlanData';
  //   const resp = await this.webapiProxyReq({planId,data},method,false);
  //   return resp.data;
  // }

  // //保存
  // static async copyPlanData(planId,data){
  //   const method = 'chanjet.EAP.QueryExt.MBSearchPlanInfo.CopyMBSearchPlan';
  //   const resp = await this.webapiProxyReq({planId,data},method,false);
  //   return resp.data;
  // }

  //获取二次过滤项
  static async getReportColumnFilterItems(args) {
    const method = 'chanjet.EAP.Report.MobileReportApi.GetReportColumnFilterItems';
    const resp = await this.webapiProxyReq({
      dto: {
        ...args
      }
    }, method, false);
    return resp;
  }

  static async getSqlTable(args) {
    const method = 'chanjet.EAP.ReferInfos.OpenApi.RefInfoOpenApi.GetSqlTable';
    const resp = await this.webapiProxyReq({
      para: args
    }
      , method, false);
    return resp.Data;
  }

  // 自定义项 需要再次获取dto对象，从dto中找出要显示的字段
  static async GetDtoByIdAndSelectFields(args) {
    const method = 'chanjet.EAP.ReferInfos.OpenApi.RefInfoOpenApi.GetDtoByIdAndSelectFields';
    const resp = await this.webapiProxyReq({
      ...args
    }
      , method, false);
    return resp.Data;
  }
}
